import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NavService } from '../../_services/_nav.service';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { ActivatedRoute, Params } from '@angular/router';
import { Location } from '@angular/common';
import { AutenticacionService } from '../../_services/autenticacion.service';
import { Seguro } from '../../_models/seguro';
import { SeguroPlan } from '../../_models/seguro-plan';
import { Table } from 'primeng/table';
import { Funcionalidad } from '../../_models/funcionalidad';
import { SeguroPlanService } from '../../_services/seguro-plan.service';
import { AppSettingService } from '../../_services/app-setting.service';

@Component( {
  selector: 'app-seguro-plan',
  templateUrl: 'seguro-plan.component.html'
} )

export class SeguroPlanComponent implements OnInit {

  @Input() seguro: Seguro;
  carInformacionInicial = true;
  codExiste = false;
  guardando = false;
  lisSegurosPlan: SeguroPlan[] = [];
  formulario: FormGroup;
  submitted = false;
  carTabla = true;
  columnas: any[];
  @ViewChild('dt') tabla: Table;
  menu: Funcionalidad = new Funcionalidad();
  segPlanSeleccionado: SeguroPlan;

  constructor( private serSeguroPlan: SeguroPlanService,
               private navServicio: NavService,
               private route: ActivatedRoute,
               private location: Location,
               private fb: FormBuilder,
               private autServicio: AutenticacionService,
               private conServicio: ConfirmationService,
               public appSettingService: AppSettingService) {
  }

  ngOnInit(): void {
    if ( this.seguro && (this.seguro.idSeguro !== '' && this.seguro.idSeguro !== null && this.seguro.idSeguro !== undefined) ) {
      /** Se traen todos los seguros planes que pertenezcan al seguro actual */
      this.serSeguroPlan.listadoPorIdSeguro( this.seguro.idSeguro ).subscribe( segurosPlanes => {
        this.lisSegurosPlan = segurosPlanes;
        this.carServiciosIniciales();
      } );
    }
  }

  carServiciosIniciales() {

    const mn = this.autServicio.obtenerFuncionalidades().find( x => x.ruta === 'apl/seguro' );
    if ( mn ) {
      this.menu = mn;
    }

    this.columnas = [
      { field: 'codigo', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_CODPLAN' ), sort: true },
      { field: 'nombre', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_NOMPLAN' ), sort: true },
      { field: 'valor', header: this.navServicio.buscarMensaje( 'SEGUROPLAN.LBL_VALORPLAN' ), sort: true },
      { field: 'indicadorHabilitado', header: this.navServicio.buscarMensaje( 'LBL_HABILITADO' ), sort: false },
      { field: 'det', header: this.navServicio.buscarMensaje( 'LBL_ACCIONES' ), sort: false }
    ];

    this.cargarFormulario();

    this.carTabla = false;
    this.carInformacionInicial = false;
  }

  cargarFormulario() {
    this.formulario = this.fb.group( {
      idSeguroPlan: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.idSeguroPlan : null ],
      idSeguro: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.idSeguro : this.seguro.idSeguro, [ Validators.required ] ],
      codigo: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.codigo : null, [ Validators.required ] ],
      nombre: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.nombre : null, [ Validators.required ] ],
      valor: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.valor : null, [ Validators.required ] ],
      indicadorHabilitado: [ this.segPlanSeleccionado ? this.segPlanSeleccionado.indicadorHabilitado : true, [ Validators.required ] ]
    } );
  }


  onSubmit() {
    this.submitted = true;
    if ( !this.codExiste && this.formulario.valid ) {
      this.guardando = true;
      const formulario = this.formulario.getRawValue();
      if ( formulario.idSeguroPlan ) {
        this.serSeguroPlan.actualizar( formulario ).subscribe( seguro => {
          this.segPlanSeleccionado.codigo = formulario.codigo;
          this.segPlanSeleccionado.nombre = formulario.nombre;
          this.segPlanSeleccionado.valor = formulario.valor;
          this.salirGuardado( false );
        } );
      } else {
        /** Se crea el seguro plan */
        this.serSeguroPlan.crear( formulario ).subscribe( seguroPlanNuevo => {
          this.lisSegurosPlan = [];
          this.serSeguroPlan.listadoPorIdSeguro( this.seguro.idSeguro ).subscribe( segurosPlanes => {
            this.lisSegurosPlan = segurosPlanes;
            this.salirGuardado( true );
          } );
        } );
      }
    } else {
      if ( this.codExiste ) {
        this.navServicio.setMesage( 0, {
          severity: 'error', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
          detail: this.navServicio.buscarMensaje( 'SEGUROPLAN.MSG_ERRORCOD' )
        } );
      }
    }
  }

  salirGuardado( crear: boolean ) {
    this.guardando = false;
    this.submitted = false;
    this.codExiste = false;
    this.formulario.reset();
    this.segPlanSeleccionado = null;
    this.cargarFormulario();
    if ( crear ) {
      this.navServicio.setMesage( 0, {
        severity: 'success', summary: this.navServicio.buscarMensaje( 'LBL_INFORMACION' ),
        detail: this.navServicio.buscarMensaje( 'SEGUROPLAN.MSG_CREO' )
      } );
    } else {
      this.navServicio.setMesage( 2 );
    }
  }

  regresar( dirty: boolean ) {
    if ( dirty ) {
      this.conServicio.confirm( {
        message: this.navServicio.buscarMensaje( 'MSG_CANCELARCAMBIOS' ),
        header: this.navServicio.buscarMensaje( 'LBL_CONFIRMACION' ),
        icon: 'fa fa-question-circle',
        key: 'plan',
        accept: () => {
          this.location.back();
        },
        reject: () => {
        }
      } );
    } else {
      this.location.back();
    }
  }

  cambiarHabilitado( seguroPlan: SeguroPlan ) {
    /** Se cambia el estado de indicadorInhabilitado del seguro plan */
    this.carInformacionInicial = true;
    /** Se Actualiza el seguro plan */
    this.serSeguroPlan.actualizar( seguroPlan ).subscribe( seguroPlanActualizado => {
      this.carInformacionInicial = false;
    } );
  }

  validarCodigo() {
    this.codExiste = this.lisSegurosPlan.find( x => x.codigo === this.f.codigo.value && (!this.segPlanSeleccionado || this.segPlanSeleccionado.idSeguroPlan !== x.idSeguroPlan) ) ? true : false;
  }


  get f() {
    return this.formulario.controls;
  }

  editar( row: SeguroPlan ) {
    this.segPlanSeleccionado = row;
    this.cargarFormulario();
  }


}
